/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import IosSwitch from "../../components/iosSwitch";
import SearchBar from "../../components/SearchBar";
import FilterMenu from "../../components/filterMenu";
import GenerateLink from "../../Modals/generateLink";
import AddtoGroup from "../../Modals/addtogroup";
import Membership from "../../Modals/membership";
import {
  formatAEDNumber,
  isValidInput,
  isValidNumber,
} from "../../utils/validations";
import { showError, showToast } from "../../constants/toasts";
import {
  useApproveMemberMutation,
  useCancelMemberMutation,
  useChangeUserBioMutation,
  useLazyCancelSubscriptionQuery,
  useLazyChangeUserStatusQuery,
  useLazyGetUserBookingHistoryQuery,
  useLazyGetUserTransactionHistoryQuery,
  useLazyMemberDetailsQuery,
  useLazyReferHistoryQuery,
  useMakeMemberVipMutation,
  useRefundSubscriptionMutation,
} from "../../service/user";
import {
  BookingHistory,
  Members,
  TransactionHistory,
} from "../../types/General";
import dayjs, { Dayjs } from "dayjs";
import EditIcon from "@mui/icons-material/Edit";
import Loader from "../../constants/Loader";
import MembershipStatusModal from "../../Modals/membershipStatusModal";
import { formatDubaiDate, formatDubaiDateTime } from "../../utils/dateTime";
import CustomPagination from "../../components/CustomPagination";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { useLazyGetSubscriptionQuery } from "../../service/subscription";
import { BOOKING_STATUS } from "../../utils/enums";
import CloseIcon from "@mui/icons-material/Close";

enum SUBSCRIPTION_TYPE {
  MONTHLY = "Monthly",
  QUARTERLY = "Quarterly",
  ANNUAL = "Annually",
  SEMI_ANNUAL = "SemiAnnually",
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
interface CutomerBookingTableProps {
  isPast?: boolean;
}
const ManageCustomerDetail = ({ isPast }: CutomerBookingTableProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");

  const { id } = useParams();
  const {
    status,
    memberType,
    partner,
    subTab,
    categoryTab,
    categoryId,
    comingFrom,
    transaction,
  } = location.state || {};

  const [userDetails] = useLazyMemberDetailsQuery();
  const [changeBio] = useChangeUserBioMutation();
  const [makeVip] = useMakeMemberVipMutation();
  const [changeStatus] = useLazyChangeUserStatusQuery();
  const [approveMember] = useApproveMemberMutation();
  const [rejectMember] = useCancelMemberMutation();
  const [transactionHistory] = useLazyGetUserTransactionHistoryQuery();
  const [bookingHistory] = useLazyGetUserBookingHistoryQuery();
  const [cancelSubscription] = useLazyCancelSubscriptionQuery();
  const [referHistory] = useLazyReferHistoryQuery();
  const [getSubscription] = useLazyGetSubscriptionQuery();
  const [refundSubscription] = useRefundSubscriptionMutation();

  const [checked, setChecked] = React.useState(true);
  const [trialDate, setTrialDate] = useState<Dayjs | null>(null);
  const [compDate, setCompDate] = useState<Dayjs | null>(null);
  const [page, setPage] = useState(1);
  const [transactionData, setTransactionData] = useState<TransactionHistory[]>(
    []
  );
  const [userLoading, setUserLoading] = useState(false);
  const [bookingData, setBookingData] = useState<BookingHistory[]>([]);
  const [count, setCount] = useState(10);
  const [bookingCount, setBookingCount] = useState(10);
  const [bookingPage, setBookingPage] = useState(1);
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    navigate(`?tab=${newValue}`, { replace: true });
    setValueTabs(newValue);
  };
  const goBack = () => {
    if (comingFrom === "booking") {
      navigate("/manage-booking-resvp", {
        state: { status: subTab, categoryTab, categoryId },
      });
    } else if (comingFrom === "cancel") {
      navigate("/manage-cancellation", {
        state: { status: subTab, categoryTab, categoryId },
      });
    } else if (transaction) {
      navigate("/transactions", {
        state: { status: subTab },
      });
    } else {
      navigate(-1);
    }
  };

  const [openModal2, setOpenModal2] = React.useState(false);
  const [openModal3, setOpenModal3] = React.useState(false);
  const [openModal4, setOpenModal4] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [refundOpen, setRefundOpen] = useState(false);

  const handleCloseModal = () => {
    setOpen(false);
  };
  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState("");

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleSaveEdit = () => {
    changeBioApi();
    setIsEditing(false);
  };

  const handleCancelEdit = () => {
    setEditText(userData?.bio || "");
    setIsEditing(false);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [bookingSearchTerm, setBookingSearchTerm] = useState("");
  const [debouncedBookingSearchTerm, setDebouncedBookingSearchTerm] =
    useState<string>("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState<Members>();
  const [membershipStatus, setMembershipStatus] = useState("Trial");
  const [selectedShortcut, setSelectedShortcut] = useState<string | null>(null);
  const [openCancel, setOpenCancel] = useState(false);
  const [referData, setReferData] = useState<any[]>([]);
  const [referPage, setReferPage] = useState(1);
  const [referCount, setReferCount] = useState(10);
  const [referSearchTerm, setReferSearchTerm] = useState("");
  const [debouncedReferSearchTerm, setDebouncedReferSearchTerm] =
    useState<string>("");
  const [subscription, setSubscription] = useState<any>([]);
  const [selectedSubscription, setSelectedSubscription] = useState<string>("");
  const [amount, setAmount] = useState<string>("");
  const [validFor, setValidFor] = useState<string>("");
  const [updateOption, setUpdateOption] = useState("no");
  const [refundAmount, setRefundAmount] = useState<string>("");
  const [refundReason, setRefundReason] = useState<string>("");
  const [refundOption, setRefundOption] = useState("yes");

  const handleShortcut = (duration: any, membershipStatus: string) => {
    let newDate = dayjs();
    switch (duration) {
      case "1w":
        newDate = newDate?.add(1, "week");
        break;
      case "1m":
        newDate = newDate?.add(1, "month");
        break;
      case "3m":
        newDate = newDate?.add(3, "month");
        break;
      case "6m":
        newDate = newDate?.add(6, "month");
        break;
      case "1y":
        newDate = newDate?.add(1, "year");
        break;
      case "10y":
        newDate = newDate?.add(10, "year");
        break;
      default:
        break;
    }
    if (membershipStatus === "Trial") {
      setTrialDate(newDate);
    } else {
      setCompDate(newDate);
    }
  };

  const approveMemberApi = async () => {
    if (!membershipStatus) {
      showError("Please select membership status");
      return;
    } else if (membershipStatus === "Trial" && !trialDate) {
      showError("Please select expiry date");
      return;
    } else if (membershipStatus === "Complementary" && !compDate) {
      showError("Please select expiry date");
      return;
    }

    if (membershipStatus === "Paid" && updateOption === "yes") {
      if (!selectedSubscription) {
        showError("Please select subscription");
        return;
      } else if (!amount) {
        showError("Please enter amount");
        return;
      } else if (!validFor) {
        showError("Please enter duration valid for");
        return;
      }
    }

    try {
      setLoading(true);
      const body = {
        memberShip:
          membershipStatus === "Complementary"
            ? "Complimentary"
            : membershipStatus,
        userId: id,
        endDate:
          membershipStatus === "Trial"
            ? trialDate?.toISOString()
            : compDate?.toISOString(),
        ...(updateOption === "yes"
          ? {
              assignMemberShip: {
                subscriptionSpecificAmount: amount,
                subscriptionId: selectedSubscription,
                validCycle: validFor,
              },
            }
          : {}),
      };

      const response = await approveMember(body).unwrap();
      setLoading(false);
      if (response.status === 200) {
        userDetailsApi();
        setOpen1(false);
        showToast("Member approved successfully");
        setTrialDate(null);
        setCompDate(null);
        setMembershipStatus("Trial");
        goBack();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const rejectMemberApi = async () => {
    if (!reason) {
      showError("Please enter reason");
      return;
    }

    try {
      setLoading(true);
      const body = {
        userId: id,
        reason: reason,
      };

      const response = await rejectMember(body).unwrap();
      setLoading(false);
      if (response.status === 200) {
        userDetailsApi();
        setOpen(false);
        showToast("Member rejected successfully");
        goBack();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const cancelSubscriptionApi = async () => {
    try {
      setLoading(true);
      const body = {
        userId: id,
        reason: reason,
      };

      const response = await cancelSubscription(body).unwrap();
      setLoading(false);
      if (response.status === 200) {
        showToast(response?.message || "");
        userDetailsApi();
        setOpenCancel(false);
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const refundSubscriptionApi = async () => {
    if (!refundAmount) {
      showError("Please enter refund amount");
      return;
    }

    if (!refundReason) {
      showError("Please enter notes");
      return;
    }

    try {
      setLoading(true);
      const body = {
        userId: id,
        refundAmount: refundAmount,
        isKeepSubscription: refundOption === "yes",
        isCancelSubscription: refundOption === "no",
        notes: refundReason,
      };

      const response = await refundSubscription(body).unwrap();
      setLoading(false);
      if (response.status === 200) {
        showToast(response?.message || "");
        userDetailsApi();
        setRefundOpen(false);
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const userDetailsApi = async () => {
    try {
      setUserLoading(true);
      const response = await userDetails({ userId: id }).unwrap();
      setUserLoading(false);
      if (response.status === 200) {
        setUserData(response?.data);
        setEditText(response?.data?.bio || "");
        setChecked(response?.data?.isActive);
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      setUserLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const changeBioApi = async () => {
    const body = {
      userId: id,
      bio: editText,
    };
    try {
      const response = await changeBio(body).unwrap();
      if (response.status === 200) {
        showToast(response?.message || "");
        userDetailsApi();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const makeUserVip = async () => {
    try {
      setLoading(true);
      const response = await makeVip({ id }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        userDetailsApi();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const handleStatusChange = async () => {
    try {
      const response = await changeStatus({ userId: id }).unwrap();
      if (response?.status === 200) {
        showToast(response?.message || "");
        userDetailsApi();
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      console.error(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const userTransactionsHistoryApi = async () => {
    try {
      setLoading(true);
      const response = await transactionHistory({
        userId: id,
        page: page,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setTransactionData(response?.data?.items || []);
        setCount(response?.data?.totalCount);
      } else {
        setTransactionData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  function getDiscountValidTillDate(
    memberShipPlan: string,
    validCycle: number,
    createdAt: string
  ): string {
    const startDate = new Date(createdAt);
    const endDate = new Date(startDate);

    if (memberShipPlan === SUBSCRIPTION_TYPE.ANNUAL) {
      endDate.setFullYear(endDate.getFullYear() + validCycle);
    } else if (memberShipPlan === SUBSCRIPTION_TYPE.SEMI_ANNUAL) {
      endDate.setMonth(endDate.getMonth() + 6 * validCycle);
    } else if (memberShipPlan === SUBSCRIPTION_TYPE.MONTHLY) {
      endDate.setMonth(endDate.getMonth() + validCycle);
    }

    return endDate.toISOString();
  }

  const userBookingHistoryApi = async () => {
    try {
      setLoading(true);
      const response = await bookingHistory({
        userId: id,
        page: bookingPage,
        search: debouncedBookingSearchTerm.trim(),
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setBookingData(response?.data?.items || []);
        setBookingCount(response?.data?.totalCount);
      } else {
        setBookingData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const userReferHistoryApi = async () => {
    try {
      setLoading(true);
      const response = await referHistory({
        userId: id,
        page: referPage,
        search: debouncedReferSearchTerm.trim(),
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setReferData(response?.data?.items || []);
        setReferCount(response?.data?.totalCount);
      } else {
        setReferData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getSubscriptionApi = async () => {
    setLoading(true);
    try {
      const response = await getSubscription({
        search: debouncedSearchTerm.trim(),
        page,
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setSubscription(response?.data?.items || []);
      } else {
        setSubscription([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    userDetailsApi();
  }, []);

  useEffect(() => {
    if (tab) {
      setValueTabs(Number(tab));
    }
  }, [tab]);

  useEffect(() => {
    userTransactionsHistoryApi();
  }, [page, debouncedSearchTerm]);

  useEffect(() => {
    if (valueTabs === 1) {
      userBookingHistoryApi();
    }
  }, [bookingPage, debouncedBookingSearchTerm, valueTabs]);

  useEffect(() => {
    userReferHistoryApi();
  }, [referPage, debouncedReferSearchTerm]);

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading || userLoading} />
        <div className="main_title">
          <h1 className="back_arrow">
            {" "}
            <IconButton onClick={() => goBack()}>
              {" "}
              <ArrowBackIcon />{" "}
            </IconButton>{" "}
            Member Profile
          </h1>
        </div>

        <div className="profile_bx profile_bx1  mt_40 mb_30">
          <div className="profile_dtl">
            <figure>
              <img
                src="/static/images/user_placeholder.png"
                alt="profile img"
              />
            </figure>
            <div className="profile_cnt">
              <h2 className="d_flx">
                {userData?.isVIP ? (
                  <img
                    style={{ height: 25, width: 25, marginRight: 5 }}
                    className="vip"
                    src="/static/images/crown.png"
                  />
                ) : null}{" "}
                {userData?.name || "-"}
              </h2>
              <p>
                {" "}
                <a>
                  {" "}
                  <IconButton>
                    <img src="/static/images/email_icon.svg" alt="icon" />
                  </IconButton>{" "}
                  {userData?.email || "-"}
                </a>
              </p>
              <p>
                {" "}
                <a>
                  {" "}
                  <IconButton>
                    <img src="/static/images/call_icon.svg" alt="icon" />
                  </IconButton>{" "}
                  {`+${userData?.phoneNumber?.countryDialCode || ""} ${userData?.phoneNumber?.phone || "-"}`}
                </a>
              </p>
            </div>
          </div>
          <div
            className="rt"
            style={{ flexWrap: "wrap", justifyContent: "end" }}
          >
            {status === "APPROVED" ? (
              <Button className="btn btn_primary" onClick={makeUserVip}>
                <img
                  style={{ height: 25, width: 25, marginRight: 5 }}
                  className="vip"
                  src="/static/images/crown_white.png"
                />{" "}
                {userData?.isVIP ? "Remove from Vip" : "Make VIP"}
              </Button>
            ) : null}

            {status === "APPROVED" ? (
              <Button
                className="btn btn_primary"
                onClick={() => setOpenModal3(true)}
              >
                {" "}
                Add to Group
              </Button>
            ) : null}

            <Button
              className="btn btn_primary"
              onClick={() => navigate(`/manage-customers/edit/${id}`)}
            >
              {" "}
              <img src="/static/images/edit_icon.svg" alt="icon" /> Edit Details
            </Button>

            {status === "REJECTED" || status === "PENDING" ? null : (
              <Button
                className="btn btn_grey"
                onClick={() => setOpenModal2(true)}
              >
                {" "}
                Generate Link
              </Button>
            )}

            {isEditing ? (
              <div
                style={{
                  width: "80%",
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: "10px",
                }}
              >
                <TextField
                  multiline
                  rows={3}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // Prevent new line
                    }
                  }}
                  value={editText}
                  onChange={(e) => setEditText(e.target.value)}
                  placeholder="Enter Bio"
                  hiddenLabel
                  fullWidth
                />
                <div style={{ display: "flex", gap: "10px" }}>
                  <Button onClick={handleSaveEdit} className="btn btn_primary">
                    Save
                  </Button>
                  <Button
                    className="btn btn_primary"
                    onClick={handleCancelEdit}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            ) : status === "APPROVED" ? (
              <p
                style={{
                  width: "80%",
                  textAlign: "right",
                  fontSize: "16px",
                  color: "#fff",
                  cursor: "pointer",
                }}
                onClick={handleEditToggle}
              >
                {editText || "No Bio"}{" "}
                <EditIcon style={{ marginLeft: "8px", cursor: "pointer" }} />
              </p>
            ) : null}
          </div>
        </div>

        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Personal Info" {...a11yProps(0)} />
                <Tab label="Booking History" {...a11yProps(1)} />
              </Tabs>
            </Box>
          </div>
          <CustomTabPanel value={valueTabs} index={1}>
            <div className="right_s">
              <SearchBar
                searchTerm={bookingSearchTerm}
                placeholder="Search...."
                setDebouncedSearchTerm={setDebouncedBookingSearchTerm}
                value={bookingSearchTerm}
                onCross={() => setBookingSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setBookingSearchTerm(val.target.value);
                  }
                }}
              />
              <FilterMenu
                startDate={null}
                endDate={null}
                setStartDate={() => {}}
                setEndDate={() => {}}
              />
            </div>
          </CustomTabPanel>
        </div>

        <CustomTabPanel value={valueTabs} index={0}>
          <div className="cards view_page">
            <div className="section_title">
              <h2>Personal Details</h2>
              <div className="btn_flex">
                {status === "PENDING" && !partner ? (
                  <>
                    <Button
                      className="btn btn_primary"
                      onClick={() => {
                        getSubscriptionApi();
                        setOpen1(true);
                      }}
                    >
                      Approve
                    </Button>
                    <Button
                      className="btn btn_primary br"
                      onClick={() => setOpen(true)}
                    >
                      Reject
                    </Button>
                  </>
                ) : null}
                {status === "APPROVED" && (
                  <>
                    {userData?.isMembershipCancel ? (
                      <Button className="btn btn_danger">Cancelled</Button>
                    ) : (
                      <>
                        <IosSwitch
                          checked={checked}
                          setChecked={setChecked}
                          onStatusChange={handleStatusChange}
                        />
                        <Button className="btn btn_primary">Approved</Button>
                      </>
                    )}
                  </>
                )}
                {status === "REJECTED" && (
                  <>
                    <Button
                      className="btn btn_primary"
                      onClick={() => setOpen1(true)}
                    >
                      Approve
                    </Button>
                    <Button className="btn btn_danger">Rejected</Button>
                  </>
                )}
                {status === "EXPIRED" && (
                  <Button className="btn btn_grey">Expired</Button>
                )}
              </div>
            </div>
            {userData?.membershipType ? (
              <div className="section_sub_title mb_30">
                {memberType === "Duo" ? (
                  <>
                    <figure>
                      <img alt="user" src="/static/images/duo_icon.svg" />
                    </figure>{" "}
                    <h3>Duo Membership</h3>
                  </>
                ) : (
                  <>
                    <figure>
                      <img alt="user" src="/static/images/single_member.svg" />
                    </figure>{" "}
                    <h3>Single Membership</h3>
                  </>
                )}
                {userData?.membership ? (
                  <span className="tag">{userData?.membership || "-"}</span>
                ) : null}
              </div>
            ) : null}

            {memberType === "Duo" ? (
              <>
                <div className="gap_p ">
                  <div className="w_25">
                    <h6>Type</h6>
                    <p>{userData?.membership || "-"}</p>
                  </div>
                  <div className="w_25">
                    <h6>Payment Method</h6>
                    <p>{"-"}</p>
                  </div>
                  <div className="w_25">
                    <h6>Created Date</h6>
                    <p>
                      {userData?.createdDate
                        ? formatDubaiDateTime(userData?.createdDate)
                        : "-"}
                    </p>
                  </div>
                  <div className="w_25">
                    <h6>Expiry Date</h6>
                    <p>
                      {userData?.subscriptionEndDate
                        ? formatDubaiDateTime(userData?.subscriptionEndDate)
                        : "-"}
                    </p>
                  </div>
                  <div className="w_25">
                    <h6>
                      {userData?.membership === "Paid"
                        ? "Next Payment"
                        : "End Date"}
                    </h6>
                    <p>
                      {" "}
                      {userData?.subscriptionEndDate
                        ? formatDubaiDateTime(userData?.subscriptionEndDate)
                        : "-"}
                    </p>
                  </div>
                  <div className="w_25">
                    <h6>Referral Code</h6>
                    <p>{userData?.refferalCode || "-"}</p>
                  </div>
                  <div className="w_25">
                    <h6>Is Referred?</h6>
                    <p>{userData?.referred ? "Yes" : "No"}</p>
                  </div>
                  <div className="w_25">
                    <h6>Payment Preference</h6>
                    <p>{userData?.paymentPreference || "-"}</p>
                  </div>
                  <div className="w_25">
                    <h6>Partner Code</h6>
                    <p>{userData?.partnerCode || "-"}</p>
                  </div>
                  <div className="w_25">
                    <h6>Last Login Date & Time</h6>
                    <p>
                      {" "}
                      {userData?.lastLogin
                        ? formatDubaiDateTime(userData?.lastLogin)
                        : "-"}
                    </p>
                  </div>
                  <div className="w_25">
                    <h6>Birthday</h6>
                    <p>
                      {" "}
                      {userData?.dateOfBirth
                        ? formatDubaiDate(userData?.dateOfBirth)
                        : "-"}
                    </p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Gender</h6>
                    <p>{userData?.gender || "-"}</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Address</h6>
                    <p>{userData?.address || "-"}</p>
                  </div>
                  <div className="w_25">
                    <h6>Field Of Expertise</h6>
                    <p>{userData?.expertiseField?.slice().join(" & ")}</p>
                  </div>
                  <div className="w_25">
                    <h6>Dietary Requirements*</h6>
                    <p>{userData?.dietary?.slice().join(" & ")}</p>
                  </div>
                  <div className="w_25">
                    <h6>Interests</h6>
                    <p>{userData?.interests?.slice().join(" & ")}</p>
                  </div>
                </div>
                <div className="control_group">
                  <hr />
                </div>
                <div className="section_title mb_20">
                  <h2>Partner Detail</h2>
                </div>
                <div className="gap_p view_page">
                  <div className="control_group w_25">
                    <h6>Name</h6>
                    <p
                      className="text_btn"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        const newId = "NEW_ID_HERE"; // replace with dynamic ID if needed

                        // Navigate to temp and then to target, both with replace
                        navigate("/blank-temp", { replace: true });

                        setTimeout(() => {
                          navigate(
                            `/manage-customers/detail/${userData?.partner?.id}`,
                            {
                              replace: true,
                              state: {
                                status,
                                memberType: userData?.membershipType,
                                partner: true,
                              },
                            }
                          );
                        }, 0);
                      }}
                    >
                      {userData?.partner?.name || "-"}
                    </p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Email</h6>
                    <p>{userData?.partner?.email || "-"}</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Phone Number</h6>
                    <p>
                      {" "}
                      {userData?.partner?.phoneNumber?.phone
                        ? `+${userData?.partner?.phoneNumber?.countryDialCode || ""} ${userData?.partner?.phoneNumber?.phone}`
                        : "-"}
                    </p>
                  </div>
                  <div className="w_25">
                    <h6>Payment Preference</h6>
                    <p>{userData?.partner?.paymentPreference || "-"}</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>
                      {userData?.membership === "Paid"
                        ? "Next Payment"
                        : "End Date"}
                    </h6>
                    <p>
                      {" "}
                      {userData?.partner?.subscriptionEndDate
                        ? formatDubaiDateTime(
                            userData?.partner?.subscriptionEndDate
                          )
                        : "-"}
                    </p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Birthday</h6>
                    <p>
                      {userData?.partner?.dateOfBirth
                        ? formatDubaiDateTime(userData?.partner?.dateOfBirth)
                        : "-"}
                    </p>
                  </div>
                  <div className="w_25">
                    <h6>Last Login Date & Time</h6>
                    <p>
                      {userData?.partner?.lastLogin
                        ? formatDubaiDateTime(userData?.partner?.lastLogin)
                        : "-"}
                    </p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Gender</h6>
                    <p>{userData?.partner?.gender || "-"}</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Address</h6>
                    <p>{userData?.partner?.address || "-"}</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Field Of Expertise</h6>
                    <p>
                      {userData?.partner?.expertiseField?.slice().join(" & ") ||
                        "-"}
                    </p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Dietary Requirements*</h6>
                    <p>
                      {" "}
                      {userData?.partner?.dietary?.slice().join(" & ") || "-"}
                    </p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Interests</h6>
                    <p>
                      {" "}
                      {userData?.partner?.interests?.slice().join(" & ") || "-"}
                    </p>
                  </div>
                </div>
                <div className="control_group">
                  <hr />
                </div>
                <div className="section_title mb_20">
                  <h2>Payment Status</h2>
                </div>
                <div className="gap_p view_page">
                  {userData?.paymentPreference === "Primary" ||
                  userData?.paymentPreference === "Split" ? (
                    <div className="control_group w_25">
                      <h6>Primary</h6>
                      <p>
                        {userData?.membership === "Paid" && userData?.isPaid
                          ? "Paid"
                          : userData?.membership === "Paid" && !userData?.isPaid
                            ? "Pending"
                            : "-"}
                      </p>
                    </div>
                  ) : null}

                  {userData?.paymentPreference === "Secondary" ||
                  userData?.paymentPreference === "Split" ? (
                    <div className="control_group w_25">
                      <h6>Secondary</h6>
                      <p>
                        {" "}
                        {userData?.membership === "Paid" && userData?.isPaid
                          ? "Paid"
                          : userData?.membership === "Paid" && !userData?.isPaid
                            ? "Pending"
                            : "-"}
                      </p>
                    </div>
                  ) : null}
                </div>
              </>
            ) : (
              <>
                <div className="gap_p ">
                  <div className="w_25">
                    <h6>Type</h6>
                    <p>{userData?.membership || "-"}</p>
                  </div>
                  <div className="w_25">
                    <h6>Payment Method</h6>
                    <p>{"-"}</p>
                  </div>
                  <div className="w_25">
                    <h6>Created Date</h6>
                    <p>
                      {userData?.createdDate
                        ? formatDubaiDateTime(userData?.createdDate)
                        : "-"}
                    </p>
                  </div>
                  {status !== "EXPIRED" && (
                    <div className="w_25">
                      <h6>
                        {userData?.membership === "Paid"
                          ? "Next Payment"
                          : "End Date"}
                      </h6>
                      <p>
                        {userData?.subscriptionEndDate
                          ? formatDubaiDateTime(userData?.subscriptionEndDate)
                          : "-"}
                      </p>
                    </div>
                  )}
                  {/* {status === "EXPIRED" && ( */}
                  <div className="w_25">
                    <h6>Expiry Date</h6>
                    <p>
                      {userData?.subscriptionEndDate
                        ? formatDubaiDateTime(userData?.subscriptionEndDate)
                        : "-"}
                    </p>
                  </div>
                  {/* )} */}
                  <div className="w_25">
                    <h6>Birthday</h6>
                    <p>
                      {userData?.dateOfBirth
                        ? formatDubaiDate(userData?.dateOfBirth)
                        : "-"}
                    </p>
                  </div>
                  <div className="w_25">
                    <h6>Gender</h6>
                    <p>{userData?.gender}</p>
                  </div>
                  <div className="w_25">
                    <h6>Address</h6>
                    <p>{userData?.address || "-"}</p>
                  </div>
                  <div className="w_25">
                    <h6>Field Of Expertise</h6>
                    <p>{userData?.expertiseField?.slice().join(" & ")}</p>
                  </div>
                  <div className="w_25">
                    <h6>Dietary Requirements*</h6>
                    <p>{userData?.dietary?.slice().join(" & ")}</p>
                  </div>
                  <div className="w_25">
                    <h6>Interests</h6>
                    <p>{userData?.interests?.slice().join(" & ")}</p>
                  </div>
                  <div className="w_25">
                    <h6>Referral Code</h6>
                    <p>{userData?.referedCode || "-"}</p>
                  </div>
                  <div className="w_25">
                    <h6>Is Referred?</h6>
                    <p>{userData?.referred ? "Yes" : "No"}</p>
                  </div>
                  <div className="w_25">
                    <h6>Last Login Date & Time</h6>
                    <p>
                      {userData?.lastLogin
                        ? formatDubaiDateTime(userData?.lastLogin)
                        : "-"}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>

          {userData?.membership ? (
            <div className="cards view_page">
              <div className="section_title">
                <h2>
                  Membership Plan{" "}
                  <span style={{ color: "red" }}>
                    {userData?.isMemberShipRefunded
                      ? "( Refunded )"
                      : userData?.isMembershipCancel
                        ? "( Cancelled )"
                        : ""}
                  </span>
                </h2>

                {userData?.membership ? (
                  <p>
                    {userData?.subscriptionEndDate
                      ? `Expiry Date - ${formatDubaiDateTime(userData?.subscriptionEndDate)}`
                      : null}
                  </p>
                ) : null}
              </div>

              <>
                <div className=" plan_grid">
                  <h3>
                    {userData?.membership || "-"}{" "}
                    <span style={{ color: "orange" }}>
                      {!userData?.isPaid && userData?.membership === "Paid"
                        ? "( Pending Payment )"
                        : ""}
                    </span>
                  </h3>
                </div>

                {userData?.isPaid && userData?.subscriptionPlan ? (
                  <>
                    <div className=" plan_grid">
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="year"
                        name="radio-buttons-group"
                        className="v2 mt_20"
                      >
                        <FormControlLabel
                          value={"year"}
                          control={<Radio />}
                          label={
                            <div className="purchase_sub_bx">
                              <p className="price">
                                <img
                                  src="/static/images/subscription_icon.svg"
                                  alt="icon"
                                />{" "}
                                <ins>{`AED ${formatAEDNumber(userData?.userSpecificplanDetails?.length ? userData?.userSpecificplanDetails[0]?.amount : userData?.subscriptionPlan?.price)}/`}</ins>
                                <sub>
                                  Per{" "}
                                  {userData?.subscriptionPlan
                                    ?.memberShipPlan ===
                                  SUBSCRIPTION_TYPE.MONTHLY
                                    ? "Month"
                                    : userData?.subscriptionPlan
                                          ?.memberShipPlan ===
                                        SUBSCRIPTION_TYPE.QUARTERLY
                                      ? "Quarter"
                                      : userData?.subscriptionPlan
                                            ?.memberShipPlan ===
                                          SUBSCRIPTION_TYPE.ANNUAL
                                        ? "Year"
                                        : "Semi Year"}
                                </sub>
                              </p>

                              {userData?.userSpecificplanDetails?.length ? (
                                <p>{`Original Price - AED ${userData?.subscriptionPlan?.price ? formatAEDNumber(userData?.subscriptionPlan?.price) : "0"}`}</p>
                              ) : null}

                              <p>
                                {userData?.subscriptionPlan?.description || "-"}
                              </p>
                            </div>
                          }
                        />
                      </RadioGroup>
                      {userData?.userSpecificplanDetails?.length ? (
                        <p style={{ marginTop: "10px" }}>
                          {`Discounted price valid till ${formatDubaiDateTime(getDiscountValidTillDate(userData?.subscriptionPlan?.memberShipPlan, userData?.userSpecificplanDetails?.[0]?.validCycle, userData?.subscriptionStartDate))}`}
                        </p>
                      ) : null}
                    </div>
                  </>
                ) : null}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "15px",
                  }}
                >
                  {userData?.isPaid ? (
                    <div className="btn_flex flx_end">
                      {userData?.membership && !userData?.isMembershipCancel ? (
                        <Button
                          className="btn btn_primary"
                          onClick={() => setOpenCancel(true)}
                        >
                          Cancel Subscription
                        </Button>
                      ) : null}
                    </div>
                  ) : null}

                  {userData?.isPaid ? (
                    <div className="btn_flex flx_end">
                      {userData?.membership && !userData?.isMembershipCancel ? (
                        <Button
                          className="btn btn_primary"
                          onClick={() => {
                            setRefundAmount(userData?.subscriptionPlan?.price);
                            setRefundOpen(true);
                          }}
                        >
                          Cancel and Refund
                        </Button>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </>
            </div>
          ) : null}

          <div className="cards view_page">
            <div className="section_title">
              <h2>Referral History</h2>
              <div className="btn_flex">
                <SearchBar
                  searchTerm={referSearchTerm}
                  placeholder="Search...."
                  setDebouncedSearchTerm={setDebouncedReferSearchTerm}
                  value={referSearchTerm}
                  onCross={() => setReferSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setReferSearchTerm(val.target.value);
                    }
                  }}
                />
              </div>
            </div>
            <div className="table_container">
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th>User Image</th>
                    <th>User Name</th>
                    <th>Email</th>
                    <th>Date</th>
                    <th>Type</th>
                  </tr>
                </thead>
                <tbody>
                  {referData?.length ? (
                    referData.map((row) => (
                      <tr key={row.id}>
                        <td>
                          <img
                            src={
                              row?.profilePictureUrl ||
                              "/static/images/user_placeholder.png"
                            }
                            alt={row?.name || "-"}
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                        </td>
                        <td>{row?.name || "-"}</td>
                        <td>{row?.email || "-"}</td>
                        <td>
                          {row?.createAt
                            ? formatDubaiDateTime(row?.createAt)
                            : "-"}
                        </td>
                        <td>{row?.memberShip || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        style={{ textAlign: "center", padding: "20px" }}
                        colSpan={5}
                      >
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {referData?.length ? (
                <CustomPagination
                  currentPage={referPage - 1}
                  totalPages={Math.ceil(referCount / 10)}
                  count={referCount}
                  pageSize={10}
                  onPageChange={(page) => setReferPage(page + 1)}
                />
              ) : null}
            </div>
          </div>
          <div className="cards view_page">
            <div className="section_title">
              <h2>Transaction History</h2>
              <div className="btn_flex">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search...."
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </div>
            </div>
            <div className="table_container">
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#C19857",
                      color: "#fff",
                      textAlign: "left",
                    }}
                  >
                    <th>Transaction ID</th>
                    <th>Membership Status</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {transactionData?.length ? (
                    transactionData?.map((row) => (
                      <tr
                        key={row?.id}
                        style={{
                          borderBottom: "1px solid #444",
                          color: "#fff",
                        }}
                      >
                        <td>
                          {row?.transactionId ? `#${row?.transactionId}` : "-"}
                        </td>
                        <td>{row?.payment || "-"}</td>
                        <td>AED {row?.amount?.toFixed(2)}</td>
                        <td
                          style={{
                            color: row?.status === "Paid" ? "green" : "orange",
                          }}
                        >
                          {row?.status || "-"}
                        </td>
                        <td>
                          {row?.createdAt
                            ? formatDubaiDateTime(row?.createdAt)
                            : "-"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={5}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {transactionData?.length ? (
                <CustomPagination
                  currentPage={page - 1}
                  totalPages={Math.ceil(count / 10)}
                  count={count}
                  pageSize={10}
                  onPageChange={(page) => setPage(page + 1)}
                />
              ) : null}
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th>Booking ID</th>

                  <th>Booking Time</th>
                  <th>Offer Name</th>
                  <th>Guests</th>
                  <th>Category</th>
                  <th>Internal Status</th>
                  <th>Date Created</th>
                  <th>Employee Name</th>
                </tr>
              </thead>
              <tbody>
                {bookingData?.length ? (
                  bookingData.map((row) => (
                    <React.Fragment key={row?.bookingId}>
                      <tr>
                        <td
                          className="cursor_p"
                          onClick={() =>
                            navigate(
                              `/manage-booking-resvp/booking-detail/${row?.bookingId}`,
                              {
                                state: {
                                  count: row?.totalNumberofGuest,
                                  internalStatus: row?.status,
                                },
                              }
                            )
                          }
                        >
                          {row?.localBookingId || "-"}
                        </td>
                        <td
                          className="cursor_p"
                          onClick={() =>
                            navigate(
                              `/manage-booking-resvp/booking-detail/${row?.bookingId}`,
                              {
                                state: {
                                  count: row?.totalNumberofGuest,
                                  internalStatus: row?.status,
                                },
                              }
                            )
                          }
                        >
                          {row?.bookingDate
                            ? formatDubaiDateTime(row?.bookingDate)
                            : "-"}
                        </td>
                        <td>{row?.offerName || "-"}</td>
                        <td>{row?.totalNumberofGuest || "0"}</td>
                        <td>{row?.categoryName || "-"}</td>
                        <td>
                          {row?.status === BOOKING_STATUS.PENDING_CANCELLATION
                            ? "Pending Cancellation"
                            : row?.status === BOOKING_STATUS.PENDING_PAYMENT
                              ? "Pending Payment"
                              : row?.status}
                        </td>
                        <td>
                          {row?.createAt
                            ? formatDubaiDateTime(row?.createAt)
                            : "-"}
                        </td>
                        <td>{row?.employeeName || "-"}</td>
                      </tr>
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={8}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {bookingData?.length ? (
              <CustomPagination
                currentPage={bookingPage - 1}
                totalPages={Math.ceil(bookingCount / 10)}
                count={bookingCount}
                pageSize={10}
                onPageChange={(page) => setBookingPage(page + 1)}
              />
            ) : null}
          </div>
        </CustomTabPanel>
      </MainContainer>

      <Modal
        className="modal rejectReason_modal"
        open={refundOpen}
        onClose={() => setRefundOpen(false)}
      >
        <div className="modal-dialog" style={{ minWidth: "40%" }}>
          <div className="modal-body">
            <div className="modal_title">
              <h2>Are you sure to refund and cancel ?</h2>
              <div
                role="button"
                tabIndex={0}
                className="btn-close"
                onClick={() => setRefundOpen(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form className="form" action="">
              <div className="control_group">
                <TextField
                  id="amount"
                  placeholder="Enter amount"
                  fullWidth
                  hiddenLabel
                  inputProps={{ maxLength: 10 }}
                  value={refundAmount}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (isValidNumber(value)) {
                      setRefundAmount(value);
                    }
                  }}
                />
              </div>

              <div className="control_group">
                <TextField
                  placeholder="Enter reason"
                  fullWidth
                  hiddenLabel
                  type="text"
                  multiline
                  maxRows={5}
                  minRows={5}
                  value={refundReason}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      setRefundReason(val.target.value);
                    }
                  }}
                />
              </div>

              <FormLabel className="form_label">Keep Membership?</FormLabel>

              <div className="control_group" style={{ margin: "0" }}>
                <FormControl className="m_radio" disabled={!memberType}>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                    value={refundOption}
                    onChange={(e) => setRefundOption(e.target.value)}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                      className="small-label"
                      sx={{
                        "&.Mui-disabled": {
                          color: "rgba(255, 255, 255, 0.3)",
                        },
                        "&.Mui-disabled .MuiFormControlLabel-label": {
                          color: "rgba(255, 255, 255, 0.3)",
                        },
                      }}
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                      className="small-label"
                      sx={{
                        "&.Mui-disabled": {
                          color: "rgba(255, 255, 255, 0.3)",
                        },
                        "&.Mui-disabled .MuiFormControlLabel-label": {
                          color: "rgba(255, 255, 255, 0.3)",
                        },
                      }}
                    />
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="footer_btn_flex">
                <Button
                  className="btn btn_primary"
                  onClick={refundSubscriptionApi}
                >
                  Submit
                </Button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        onClick={() => {
          rejectMemberApi();
          setOpen(false);
        }}
        setReason={setReason}
        reason={reason}
      />

      <MembershipStatusModal
        open={open1}
        onClose={handleCloseModal1}
        setOpen={setOpen1}
        setMembershipStatus={setMembershipStatus}
        membershipStatus={membershipStatus}
        setTrialDate={setTrialDate}
        trialDate={trialDate}
        setCompDate={setCompDate}
        compDate={compDate}
        onClick={approveMemberApi}
        memberType={memberType}
        handleShortcut={handleShortcut}
        setSelectedShortcut={setSelectedShortcut}
        selectedShortcut={selectedShortcut}
        subscription={subscription}
        setSelectedSubscription={setSelectedSubscription}
        selectedSubscription={selectedSubscription}
        amount={amount}
        setAmount={setAmount}
        validFor={validFor}
        setValidFor={setValidFor}
        updateOption={updateOption}
        setUpdateOption={setUpdateOption}
      />

      <GenerateLink
        open={openModal2}
        onClose={() => setOpenModal2(false)}
        setOpen={setOpenModal2}
        type="userManagement"
        userId={id}
        loading={loading}
        setLoading={setLoading}
      />
      <AddtoGroup
        open={openModal3}
        onClose={() => setOpenModal3(false)}
        setOpen={setOpenModal3}
        memberId={id}
      />
      <Membership
        open={openModal4}
        onClose={() => setOpenModal4(false)}
        setOpen={setOpenModal4}
      />

      <ConfirmationModal
        text={"Are you sure to cancel this subscription?"}
        openModal={openCancel}
        setOpenModal={setOpenCancel}
        handleSubmit={cancelSubscriptionApi}
      />
    </>
  );
};

export default ManageCustomerDetail;
